module.exports = __webpack_public_path__ + "static/media/X1.2e6583a0.png";